import { createSignal, Show } from 'solid-js'
import type { Component } from 'solid-js'
import { getClerk } from '@utils/clerk'
import { log, warn } from '@utils/logger'

const Login: Component = () => {
  const [email, setEmail] = createSignal('')
  const [password, setPassword] = createSignal('')
  const [loading, setLoading] = createSignal(false)
  const [error, setError] = createSignal<string | null>(null)

  // Use Clerk JS SDK to perform OAuth via Google
  const signInWithGoogle = async () => {
    setError(null)
    try {
      const clerk = await getClerk()
      // Ensure Clerk is fully initialized (populates .client and other internals)
      if (typeof clerk.load === 'function') await clerk.load()
      // Diagnostic logs to help debug undefined client
      // eslint-disable-next-line no-console
      console.debug('Clerk instance:', clerk)
      // eslint-disable-next-line no-console
      console.debug('Clerk client:', (clerk as any)?.client)
      if (!(clerk as any)?.client) {
        throw new Error('Clerk client is undefined on the initialized Clerk instance')
      }
      const signIn = await clerk.client.signIn.create({
        strategy: 'oauth_google',
        redirectUrl: window.location.href,
      })

      // Trigger the OAuth redirect flow
      await (signIn as any).authenticateWithRedirect({
        strategy: 'oauth_google',
        redirectUrl: window.location.href,
      })
    } catch (err: any) {
      // eslint-disable-next-line no-console
      console.error('Clerk Google sign-in error:', err)
      setError(err?.message || 'Unable to sign in with Google. Please contact support.')
    }
  }

  const submit = async (e?: Event) => {
    if (e && typeof (e as Event).preventDefault === 'function') (e as Event).preventDefault()
    // Preserve the loading state for the redirect trigger
    setLoading(true)
    try {
      await signInWithGoogle()
    } finally {
      setLoading(false)
    }
  }

  return (
    <div class="grow flex items-center justify-center p-6">
      <form class="w-full max-w-sm bg-zinc-900 border border-zinc-800 rounded-lg p-6" onSubmit={submit}>
        <h2 class="text-2xl font-semibold text-white mb-4">Sign in</h2>

        <div class="mb-4">
          <button
            type="button"
            class="w-full mb-2 bg-white/10 text-white py-2 rounded font-medium hover:bg-white/20"
            onClick={signInWithGoogle}
            disabled={loading()}
          >
            Continue with Google
          </button>
        </div>

        <Show when={error()}>
          <div class="mt-2 p-2 bg-red-900 text-red-100 rounded text-sm" role="alert">{error()}</div>
        </Show>
      </form>
    </div>
  )
}

export default Login
